export { default } from './UserProfileService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/services/UserProfileService/index.js